import React from 'react';
import PropTypes from 'prop-types';
import utils from '../../../../common/utils';
import { getCachedImageURLFromURL } from '../../../../common/images';

/**
 * Giphy component
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const Giphy = props => {
  const {
    params,
    style,
    groupAngle,
    groupScaleX,
    globalScale,
    applyScaleFix,
  } = props;
  const { shadow, scaleX } = params;
  const localScale = (scaleX / groupScaleX) * (applyScaleFix ? globalScale : 1);

  const blockStyles = {
    ...style,
    backgroundColor: 'transparent',
    overflow: 'hidden',
    pointerEvents: 'none',
    opacity: props.groupOpacity,
    filter: shadow
      ? utils.getDropShadowCSSFilterFromFabricShadow(
          shadow,
          groupAngle,
          localScale,
        )
      : 'none',
  };

  const url = params.ludus.url;
  const slug = url.substr(url.lastIndexOf('/') + 1);
  const id = slug.substr(slug.lastIndexOf('-') + 1);
  const cloudinaryURL = getCachedImageURLFromURL(
    `https://i.giphy.com/media/${id}/giphy.gif`,
  );

  return (
    <div style={blockStyles}>
      <img
        alt="GIPHY"
        key={`giphy-${id}`}
        src={cloudinaryURL}
        width={style.width}
        height={style.height}
      />
    </div>
  );
};

Giphy.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  applyScaleFix: PropTypes.bool.isRequired,
  globalScale: PropTypes.number.isRequired,
  groupAngle: PropTypes.number.isRequired,
  groupOpacity: PropTypes.number.isRequired,
  groupScaleX: PropTypes.number.isRequired,
};
Giphy.defaultProps = {
  hyperlink: null,
};

export default Giphy;
